import React from 'react';
import { Progress } from '@chakra-ui/react';

function ProgressBar() {
  return (
    <div className="w-100 h-100 bg-white bg-opacity-50 min-vw-100 min-vh-100 text-center position-absolute z-1 top-0">
      <Progress size="xs" isIndeterminate className="mt-1" colorScheme="pink" />
    </div>
  );
}

export default ProgressBar;
